import MIDIFile from 'midifile';
import MIDIEvents from 'midievents';
// import piu from 'piu';
// import teoria from 'teoria';
import FileSaver from 'file-saver';
import _ from 'lodash';

const MIDIEventInfo = {};
// Event types
MIDIEventInfo[0xFF] = "META";
MIDIEventInfo[0xF0] = "SYSEX";
MIDIEventInfo[0xF7] = "DIVSYSEX";
MIDIEventInfo[0x8] = "MIDI";
// Meta Events
MIDIEventInfo[0x00] = "Sequence Number";
MIDIEventInfo[0x01] = "Text";
MIDIEventInfo[0x02] = "Copyright Notice";
MIDIEventInfo[0x03] = "Track Name";
MIDIEventInfo[0x04] = "Instrument Name";
MIDIEventInfo[0x05] = "Lyrics";
MIDIEventInfo[0x06] = "Marker";
MIDIEventInfo[0x07] = "Cue Point";
MIDIEventInfo[0x20] = "Midi Channel Prefix";
MIDIEventInfo[0x2F] = "End Of Track";
MIDIEventInfo[0x51] = "Set Tempo";
MIDIEventInfo[0x54] = "SMTPE Offset";
MIDIEventInfo[0x58] = "Time Signature";
MIDIEventInfo[0x59] = "Key Signature";
MIDIEventInfo[0x7F] = "Sequencer Specific";

class MidiToChordOrgan {
  constructor() {
    this.defaultChords = [
        [0,4,7,12,0],
        [0,3,7,12,0],
        [0,4,7,11,0],
        [0,3,7,10,0],
        [0,4,7,11,14],
        [0,3,7,10,14],
        [0,5,7,12,0],
        [0,7,12,0,7],
        [0,5,12,0,5],
        [0,4,7,8,0],
        [0,3,7,8,0],
        [0,3,6,0,3],
        [0,4,8,0,4],
        [0,0,0,0,0],
        [-12,-12,0,0,0],
        [-12,0,0,12,24]
    ];
    this.chordList = [];
    this.maximumChordCount = 16;
    this.maximumNotesPerChord = 8;
    this.allEvents = [];
    // List of all time deltas with note information
    this.noteEventTimes = [];
    this.totalNoteCount = 0;
  }

  processMidi(arrayBuffer) {
    // console.log('Process Midi');
    let midiFile = new MIDIFile(arrayBuffer);
    let info = {};
    info.format = midiFile.header.getFormat();

    if(info.format === 2) {
      console.warn("Type 2 Midi Files not supported");
      throw new Error("Type 2 Midi not supported.");
    }

    // Gather all events across all tracks for each time delta into their own collections
    this.allEvents = [];
    this.noteEventTimes = [];
    this.totalNoteCount = 0;
    this.chordMap = {};

    info.trackCount = midiFile.header.getTracksCount();
    // console.log('Format', midiFile.header.getFormat());
    // console.log('Tracks', midiFile.header.getTracksCount());

    for(let i=0;i<info.trackCount;i++) {
      // console.log('Process Track',i);
      this.processTrack(midiFile.getTrackEvents(i));
    }

    // console.log('All Events',this.allEvents);
    // Now process meta events for tempo, ticks per clock etc..
    this.processMetaEvents();

    // console.log('Total Notes',this.totalNoteCount);
    // console.log('Note Event Times',this.noteEventTimes);

    let sortedTimes = this.processNoteEventTimes();

    this.extractChords(sortedTimes);

    this.chordList = this.rerootChords(this.chordList);

    let chordListString = '';
    let index = 1;
    this.chordList.forEach(function (chord) {
      chordListString += index + ' [' + chord.join(',') + ']\n';
      index++;
    });

    this.chordListString = chordListString;

    // console.log("Chord List",this.chordList);
    info.chordCount = this.chordList.length;
    return info;

  }

  processNoteEventTimes() {
    let minDiff = 1000000;
    let maxDiff = 0;
    let sortedTimes = _.sortedUniq(this.noteEventTimes.sort((a, b) => (a - b)));
    // console.log('Sorted Times',sortedTimes);
    for(let i=1;i<sortedTimes.length;i++) {
      let dt = sortedTimes[i] - sortedTimes[i-1];
      if(dt > maxDiff) maxDiff = dt;
      if(dt < minDiff) minDiff = dt;
    }
    // console.log('Min/Max',minDiff,maxDiff);
    return sortedTimes;
  }

  // returns boolean : have we got enough notes to fill all chords slots with
  // the maximum number of notes
  processTrack(events) {
    let t = 0;
    // Note and Meta events at current time
    let notes = [];
    let meta = [];
    for (let i = 0; i < events.length; i++) {
      let e = events[i];
      if(e.delta) {
        if(this.addEventsAt(t, notes, meta)) {
          return true;
        }
        t += e.delta;
        // console.log('Time ', t);
        notes = [];
        meta = [];
      }
      if (e.type === MIDIEvents.EVENT_MIDI) {
        if (e.subtype === MIDIEvents.EVENT_MIDI_NOTE_ON) {
          // console.log("Note On ", e.param1);
          notes.push(e.param1);
        }
      } else if(MIDIEventInfo[e.type]) {
        if(e.type === MIDIEvents.EVENT_META) {
          let name = MIDIEventInfo[e.subtype];
          // console.log('Meta Event', name);
          // store whole event
          meta.push({name:name,event:e});
        } else {
          console.log('Unknown Event Type ',MIDIEventInfo[e.type]);
        }
      }
    }
    return this.addEventsAt(t, notes, meta);
  }

  processMetaEvents() {
    // if(e.subtype === MIDIEvents.EVENT_META_TIME_SIGNATURE) {
    //   console.log('Set Clocks Per Tick',e.param3);
    //   this.clocksPerTick = e.param3;
    // }

  }

  // returns boolean : have we got enough notes to fill all chords slots with
  // the maximum number of notes
  addEventsAt(time, notes, meta) {
    if(notes.length === 0 && meta.length === 0) return;

    // console.log('Add Events At',time,notes.length,meta.length);

    if(notes.length > 0) {
      this.noteEventTimes.push(time);
    }

    let numericSort = (a, b) => (a - b);
    if(this.allEvents[time]) {
      let here = this.allEvents[time];
      // There might be duplicates here, filter them later.
      let currentNoteCountHere = here.notes.length;
      let newNotes = here.notes.concat(notes);
      here.notes = _.sortedUniq(newNotes.sort(numericSort));
      // Add the amount of new notes
      this.totalNoteCount += here.notes.length - currentNoteCountHere;
      here.meta = here.meta.concat(meta);
    } else {
      let newNotes = _.sortedUniq(notes.sort(numericSort));
      this.allEvents[time] = {notes:newNotes,meta:meta};
      this.totalNoteCount += newNotes.length;
    }
    // Need to add some overflow because time ranges with less than 3 notes can be discarded
    // TODO : Parse midi files in chunks, only parse extra if we need it for more chords
    return this.totalNoteCount > ((this.maximumChordCount * this.maximumNotesPerChord * 4));
  }

  extractChords(sortedNoteTimes) {
    this.chordList = [];
    let currentChord = [];

    let quantiseTicks = 32;

    let delta = 0;
    let lastNoteTime = 0;
    for (let i = 0; i < sortedNoteTimes.length; i++) {
      let noteTime = sortedNoteTimes[i];
      delta = noteTime - lastNoteTime;
      let notes = this.allEvents[noteTime].notes;
      if(delta < quantiseTicks) {
        // This set of notes is within quantise time, add it to current set
        if(notes.length + currentChord.length < 8) {
          // console.log('Adding notes to current chord',currentChord, notes);
          currentChord = _.sortedUniq(currentChord.concat(notes).sort((a,b) => (a-b)));
        } else {
          // Too many new notes to fit in this chord, make a new one instead
          // console.log('Current chord is full, making new',currentChord,notes);
          if(!this.addChord(currentChord)) {
            return;
          }

          currentChord = notes;
          lastNoteTime = noteTime;
        }
      } else {
        // console.log('Outside quantise time, new chord',currentChord, notes);
        // Outside of quantise time, make new chord
        if(!this.addChord(currentChord)) {
          return;
        }
        currentChord = notes;
        lastNoteTime = noteTime;
      }
    }
    this.addChord(currentChord);

  }

  exportChordOrganFile(settings) {
    if(this.chordList.length > 0) {
      this.exportChordFile(settings);
    } else {
      this.exportChordFile(settings);
    }

  }

  // Returns success : boolean. True if chord was added to main list, false if list is full.
  addChord(chord) {
    if (this.chordList.length === 16) {
      // console.warn('Chord list is full with 16 chords, ignoring');
      return false;
    }

    if(chord.length < 3) {
      return true;
    }

    chord.sort();
    let chordMapKey = chord.join(",");
    // Have we already seen this chord
    if(this.chordMap[chordMapKey]) {
      return true;
    } else {
      this.chordMap[chordMapKey] = true;
    }

    // console.log('Adding chord', chord);

    // let mappedNotes = chord.map(teoria.note.fromMIDI);
    // let mappedNoteNames = mappedNotes.map(function (n) {
    //   return n.toString();
    // });
    // console.log('Mapped Notes', mappedNoteNames);
    // let chordName = piu.infer(mappedNotes, false);
    // console.log('Chord', chordName);

    if (chord.length > 8) {
      // console.log('Chord has more than 8 notes, slicing');
      chord = chord.slice(0, 8);
    }
    this.chordList.push(chord);
    return true;
  };

  rerootChords(chordList) {
    let root = chordList[0][0];
    // console.log('ReRooting Chord List', root);
    let mapped = chordList.map(function (chord) {
      return chord.map(function (note) {
        return note - root;
      })
    });
    return mapped;
  };

  getDefaultChordString() {
    let chordString = "";
    for(let i=0;i<this.defaultChords.length;i++) {
      let chord = this.defaultChords[i];
      chordString += (i+1).toString() + " [" + chord.join(",") + "]\n";
    }
    return chordString;
  }

  exportChordFile(settings) {
    console.log('Export chord file', this);
    let musicThing = "o   o o   o  o-o  o-O-o   o-o   o-O-o o  o o-O-o o   o  o-o \n|\\ /| |   | |       |    /        |   |  |   |   |\\  | o\n| O | |   |  o-o    |   O         |   O--O   |   | \\ | |  -o\n|   | |   |     |   |    \\        |   |  |   |   |  \\| o   |\no   o  o-o  o--o  o-O-o   o-o     o   o  o o-O-o o   o  o-o\n";
    let chordOrgan = "  o-o o  o  o-o  o--o  o-o        o-o  o--o   o-o    O  o   o\n /    |  | o   o |   | |  \\      o   o |   | o      / \\ |\\  |\nO     O--O |   | O-Oo  |   O     |   | O-Oo  |  -o o---o| \\ |\n \\    |  | o   o |  \\  |  /      o   o |  \\  o   | |   ||  \\|\n  o-o o  o  o-o  o   o o-o        o-o  o   o  o-o  o   oo   o\n";

    let settingsString = "# CONFIG / FIRMWARE VERSION 0.6 #\n";

    console.log('Settings',settings);
    if(settings.extraWaves) {
      settingsString += "!WAVES\n";
    }
    if(settings.stacked) {
      settingsString += "!STACK\n";
    }
    if(settings.glide) {
      settingsString += "!GLIDE " + settings.glideTime + "\n";
    }
    if(settings.customNoteRange) {
      settingsString += "!RANGE " + settings.noteRange + "\n";
    }

    if(!settings.quantiseRootKnob || !settings.quantiseRootCV) {
      settingsString += "!FREEROOT";
      if(!settings.quantiseRootKnob && !settings.quantiseRootCV) {
        settingsString += " BOTH";
      } else if(!settings.quantiseRootKnob) {
        settingsString += " KNOB";
      }
      settingsString += "\n";
    }

    let chordString = "";
    if(settings.chordText === undefined || settings.chordText.length === 0) {
      if(this.chordListString === undefined) {
        chordString = this.getDefaultChordString();
      } else {
        chordString = this.chordListString;
      }
    } else {
      chordString = settings.chordText;
    }

    let blob = new Blob([musicThing + '\n' + chordOrgan + '\n' + settingsString + '\n' + chordString + '\n'], {type: "text/plain;charset=utf-8"});
    FileSaver.saveAs(blob, 'CHORDORG.TXT');
  };

}

export default MidiToChordOrgan;


// WEBPACK FOOTER //
// ./src/MidiToChordOrgan.js